import styled from 'styled-components';

export const CartTableString = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 70px;
    min-height: 50px;
    color: var(--color-title);
    padding: 5px 0;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;

    &:nth-child(2n+1) {
        background-color: #f3f6f760;
    }

    & div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 20px;
        flex-wrap: wrap;
    }

    & div img {
        width: 30px;
        height: auto;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr auto;
        border: 1px solid var(--color-bg-gray);
        border-radius: 5px;
        padding: 5px 10px;
        grid-row-gap: 10px;
        margin-bottom: 5px;

        & div {
            padding: 0;
        }
    }
`